import ScannerError from '../types/abstract/ScannerError';

export default class ScannerUnexpectedError extends ScannerError {
  constructor() {
    super('An unexpected error occurred with the scanner, please refresh the page', {
      button: { text: 'Refresh the page', URL: window.location.href },
    });
  }
}
